import { defineMessages } from 'react-intl';

const newMessages = defineMessages({
  businessAccountTitle: {
    id: 'business.accounts.title',
    defaultMessage: 'Business Information',
    description: 'Title for the business account section',
  },
  claimYourBusiness: {
    id: 'business.accounts.claimYourBusiness',
    defaultMessage: 'Claim Your Business',
    description: 'Button label to claim a business',
  },
  companyName: {
    id: 'business.accounts.companyName',
    defaultMessage: 'Company',
    description: 'Label for the company name field',
  },
  editCompanyName: {
    id: 'business.accounts.editCompanyName',
    defaultMessage: 'Edit company name',
    description: 'Title for editing the company name',
  },
  businessName: {
    id: 'business.accounts.businessName',
    defaultMessage: 'Business name',
    description: 'Label for the business name field',
  },
  businessNameHint: {
    id: 'business.accounts.businessNameHint',
    defaultMessage:
      'Please enter the name of your farm business. If you do not have a business name, enter your first name and surname.',
    description: 'Hint text for the business name field',
  },
  businessAddress: {
    id: 'business.accounts.businessAddress',
    defaultMessage: 'Business address',
    description: 'Label for the business address field',
  },
  onlyNumbersError: {
    id: 'business.accounts.validation.onlyNumbersError',
    defaultMessage:
      'Please enter a valid Business name. It should contain at least one character that is not a number.',
    description: 'Error message when the Business name contains only numbers',
  },
  improperCaseError: {
    id: 'business.accounts.validation.improperCaseError',
    defaultMessage: 'Please use the title case naming convention for the Business name.',
    description: 'Error message for Business name entered in improper case',
  },
  invalidCharactersError: {
    id: 'business.accounts.validation.invalidCharactersError',
    defaultMessage: 'Please only use alphanumeric characters or the following special characters: - . / *',
    description: 'Error message when the Business name contains invalid characters',
  },
  minimumCharactersError: {
    id: 'business.accounts.validation.minimumCharactersError',
    defaultMessage: 'Please enter at least 2 characters for the Business name.',
    description: 'Error message when the Business name contains less than 2 characters',
  },
  legalEntity: {
    id: 'business.accounts.legalEntity',
    defaultMessage: 'Legal Entity',
    description: 'Label for the legal entity field',
  },
  editLegalEntity: {
    id: 'business.accounts.editLegalEntity',
    defaultMessage: 'Edit legal entity',
    description: 'Title for editing the legal entity',
  },
  businessType: {
    id: 'business.accounts.businessType',
    defaultMessage: 'Business type',
    description: 'Label for the business type field',
  },
  editBusinessType: {
    id: 'business.accounts.editBusinessType',
    defaultMessage: 'Edit business type',
    description: 'Title for editing the business type',
  },
  farmType: {
    id: 'business.accounts.farmType',
    defaultMessage: 'Farm type',
    description: 'Label for the farm type field',
  },
  editFarmType: {
    id: 'business.accounts.editFarmType',
    defaultMessage: 'Edit farm type',
    description: 'Title for editing the farm type',
  },
  companyRegistrationNumber: {
    id: 'business.accounts.companyRegistrationNumber',
    defaultMessage: 'Company registration number',
    description: 'Label for the company registration number field',
  },
  editCompanyRegistrationNumber: {
    id: 'business.accounts.editCompanyRegistrationNumber',
    defaultMessage: 'Edit company registration number',
    description: 'Title for editing the company registration number',
  },
  addBusinessType: {
    id: 'business.accounts.addBusinessType',
    defaultMessage: 'Add business type',
    description: 'Title for adding a business type',
  },
  entityType: {
    id: 'business.accounts.entityType',
    defaultMessage: 'Entity type',
    description: 'Label for the entity type field',
  },
  editEntityType: {
    id: 'business.accounts.editEntityType',
    defaultMessage: 'Edit entity type',
    description: 'Title for editing the entity type',
  },
  selectEntityType: {
    id: 'business.accounts.selectEntityType',
    defaultMessage: 'Select entity type',
    description: 'Placeholder for the entity type dropdown',
  },
  entityTypeCompany: {
    id: 'business.accounts.entityTypeCompany',
    defaultMessage: 'Company',
    description: 'Option for the entity type dropdown',
  },
  entityTypeIndividual: {
    id: 'business.accounts.entityTypeIndividual',
    defaultMessage: 'Individual',
    description: 'Option for the entity type dropdown',
  },
  entityTypeUnkown: {
    id: 'business.accounts.entityTypeUnkown',
    defaultMessage: 'Unknown',
    description: 'Option for the entity type dropdown',
  },
  businessChangedSuccessSnackMessageTitle: {
    id: 'business.businessChangedSuccessSnackMessageTitle',
    defaultMessage: 'Business changed successfully.',
    description: 'Business changed successfully snack message title',
  },
  businessChangedSuccessSnackMessageDescription: {
    id: 'business.businessChangedSuccessSnackMessageDescription',
    defaultMessage: 'You are now viewing {newBusinessName}.',
    description: 'Business changed snack message description',
  },
});

export default newMessages;
